import React from "react";
import { icons } from "../../assets/icons";
import { useNavigate } from "react-router-dom";

const ToolbarHeader = ({
  title = "",
  showBack = true,
  renderLeft,
  renderRight,
  containerClassName = "",
}) => {
  const navigate = useNavigate();
  const onClickBack = () => {
    navigate(-1);
  };

  return (
    <div className={`flex justify-between ${containerClassName}`}>
      <div className="flex items-center gap-x-6">
        {showBack && (
          <div onClick={onClickBack}>
            <img
              src={icons.backIcon}
              alt="back icon"
              className="w-[2.7rem] h-[1.7rem] cursor-pointer"
            />
          </div>
        )}
        {renderLeft ? (
          renderLeft()
        ) : (
          <div className="text-[3rem] font-family-medium text-[var(--blackColor)]">
            {title}
          </div>
        )}
      </div>
      {renderRight ? renderRight() : null}
    </div>
  );
};

export default ToolbarHeader;
